/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { useEffect, useState } from 'react';
import { Box, Chip, Typography, Stack, Switch, FormControlLabel } from '@mui/material';
import { getOnlineOfflineStatus, updateOnlineOfflineStatus } from '../../../../../services/network/networkController';

const NetworkStatus = () => {
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchStatus();
    }, []);

    const fetchStatus = async () => {
        try {
            const result = await getOnlineOfflineStatus();
            setStatus(result);
        } catch (error) {
            console.error("Failed to fetch status", error);
            setStatus('Unknown');
        }
    };

    const handleStatusToggle = async (event) => {
        const newStatus = event.target.checked ? 'Online' : 'Offline';
        setLoading(true);
        try {
            await updateOnlineOfflineStatus({ status: newStatus });
            setStatus(newStatus);
        } catch (error) {
            console.error('Failed to update status', error);
        } finally {
            setLoading(false);
        }
    };


    const getStatusChip = () => {
        if (status === 'Online') return <Chip label="Online" color="success" />;
        if (status === 'Offline') return <Chip label="Offline" color="error" />;
        return <Chip label="Unknown" color="default" />;
    };

    return (
        <Box
            sx={{
                p: 3,
                borderRadius: 3,
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                maxWidth: 500,
            }}
        >
            <Typography variant="h4" gutterBottom fontWeight={600}>
                Network Status
            </Typography>

            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
                {getStatusChip()}

                <FormControlLabel
                    control={
                        <Switch
                            checked={status === 'Online'}
                            onChange={handleStatusToggle}
                            disabled={loading}
                            color="primary"
                        />
                    }
                    label={status === 'Online' ? 'Online' : 'Offline'}
                />


            </Stack>
        </Box>
    );
};

export default NetworkStatus;
